import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";

import UserMenu from '../UserMenu';
import iconBell from "src/Assets/icons/icon_bell.svg";
import iconMessage from "src/Assets/icons/icon_message.svg";
import iconNotification from "src/Assets/icons/icon_notification.svg";

import NotificationsPopup from '../NotificationsPopup';
import MessagesPopup from '../MessagesPopup';

function Navbar(props) {
    const {
        sidebarOpen,
        setSidebarOpen,
        title,
        subtitle
    } = props;

    const session = useSelector((state) => state.session);
    const [notifications, setNotifications] = useState(null);
    const [messages, setMessages] = useState(null);
    const [pendingNotifications, setPendingNotificactions] = useState(false);
    const [pendingMessages, setPendingMessages] = useState(false);

    return (
        <nav className="z-30 w-full bg-slate" style={{ zIndex: 3, position: 'sticky', top: 0}}>
            <div className="py-2 px-2 md:px-7">
                <div className="flex items-center justify-between">
                    <div className="flex items-center justify-start flex-1 min-w-0">
                        <button onClick={() => setSidebarOpen(!sidebarOpen)} aria-expanded="true" aria-controls="sidebar" className="md:hidden mr-2 text-blue hover:text-gray-900 cursor-pointer p-2 hover:bg-gray-100 focus:bg-gray-100 focus:ring-2 focus:ring-gray-100 rounded flex-shrink-0">
                            <svg id="toggleSidebarMobileHamburger" className={`w-6 h-6 ${sidebarOpen ? 'hidden' : ''}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd"></path></svg>
                            <svg id="toggleSidebarMobileClose" className={`w-6 h-6 ${!sidebarOpen ? 'hidden' : ''}`} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                        </button>
                        <div className="min-w-0">
                            <p className='text-base sm:text-xl lg:text-3xl text-medium truncate'>
                                {title ? title : '¡Hola ' + (session.user?.fullName ? session.user?.fullName+'!'  : session.user?.name+' '+ session.user?.lastName+'!') }
                            </p>

                            {!title&&
                                <p className="text-xs sm:text-base lg:text-xl text-light truncate">
                                    { session.user?.group ? session.user?.group?.name : ' '}
                                </p>
                            }

                            {subtitle && (
                                <p className="text-xs sm:text-base lg:text-xl text-light truncate">
                                    { subtitle ? subtitle : ' '}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className="flex items-center flex-shrink-0">

                        <button
                            className='relative'
                            onClick={(e)=>setNotifications(e.currentTarget)}
                        >
                            <img
                                src={iconBell}
                                alt=""
                                className="w-5 sm:w-7 h-auto mx-1 sm:mx-2"
                            />
                            {pendingNotifications&&
                                <span className="top-0 left-5 sm:left-6 absolute bg-green text-xs font-medium p-1.5 rounded-full"/>
                            }
                        </button>

                        <button
                            className='relative'
                            onClick={(e)=>setMessages(e.currentTarget)}
                        >
                            <img
                                src={iconMessage}
                                alt=""
                                className="w-5 sm:w-7 h-auto mx-1 sm:mx-2"
                            />
                            {pendingMessages&&
                                <span className="top-0 left-5 sm:left-6 absolute bg-green text-xs font-medium p-1.5 rounded-full"/>
                            }
                        </button>
                        <UserMenu/>
                    </div>
                </div>
            </div>

            <NotificationsPopup
                show={notifications}
                setShow={setNotifications}
                setPending={setPendingNotificactions}
            />

            <MessagesPopup
                show={messages}
                setShow={setMessages}
                setPending={setPendingMessages}
            />
        </nav>
    );
}

export default Navbar;
